import React from 'react';

import {useTranslation} from 'react-i18next';
import {useHistory} from 'react-router-dom';

import {PermissionAccess} from 'components/common/PermissionAccess';
import {DropdownMenu} from 'components/ui-kit/DropdownMenu';
import {ROUTE} from 'core/routes';

import {UserPermission} from 'types/auth';

import {ControlsWrapper} from './styled';

export const Controls = () => {
    const {t} = useTranslation();
    const history = useHistory();
    return (
        <ControlsWrapper>
            <PermissionAccess
                permissions={[
                    UserPermission.ORDER_CREATE_CUSTOMER,
                    UserPermission.ORDER_CREATE_TRANSPORT,
                    UserPermission.ORDER_CREATE_CUSTOMS,
                ]}
            >
                <DropdownMenu label={t('pages.orders.create')}>
                    <DropdownMenu.List>
                        <PermissionAccess permissions={[UserPermission.ORDER_CREATE_CUSTOMER]}>
                            <DropdownMenu.Item
                                onSelect={() => history.push(ROUTE.ORDERS_CREATE_CUSTOMER)}
                            >
                                {t('pages.orders.createConsumerCodes')}
                            </DropdownMenu.Item>
                        </PermissionAccess>
                        <PermissionAccess permissions={[UserPermission.ORDER_CREATE_TRANSPORT]}>
                            <DropdownMenu.Item
                                onSelect={() => history.push(ROUTE.ORDERS_CREATE_TRANSPORT)}
                            >
                                {t('pages.orders.createTransportCodes')}
                            </DropdownMenu.Item>
                        </PermissionAccess>
                        <PermissionAccess permissions={[UserPermission.ORDER_CREATE_CUSTOMS]}>
                            <DropdownMenu.Item
                                onSelect={() => history.push(ROUTE.ORDERS_CREATE_CUSTOMS)}
                            >
                                {t('pages.orders.createCustomsCodes')}
                            </DropdownMenu.Item>
                        </PermissionAccess>
                    </DropdownMenu.List>
                </DropdownMenu>
            </PermissionAccess>
        </ControlsWrapper>
    );
};
